<script setup>
import Hero from "./components/Search/Hero.vue";
import FilterModal from "./components/Filter/FilterModal.vue";
import { useResultsStore } from "./stores/results";
import { ModalsContainer, useModal } from "vue-final-modal";
import { useFilterStore } from "./stores/filter";
import { useCollectionStore } from "./stores/collection";
import InfiniteArticleList from "./components/ArticleList/InfiniteArticleList.vue";
import ArticleRelationItemList from "./components/ArticleRelationItemList/ArticleRelationItemList.vue";
import { ref } from "vue";

// Stores
const filterStore = useFilterStore();
const resultsStore = useResultsStore();
const collectionStore = useCollectionStore();

// Reloading
const isReloading = ref(true);

// Filter Modal
const filterModal = useModal({
  component: FilterModal,
  attrs: {
    onClose() {
      filterModal.close();
    },
    onClosed() {
      if (filterStore.searchTerm !== "") {
        load();
      }
    },
  },
});

// Order
function toggleOrder() {
  filterStore.toggleOrder();
  window.klarnachrichten.trackMatomoEvent("toggle-order", filterStore.order);

  if (filterStore.searchTerm !== "") {
    load();
  }
}

// Search
function onSearch() {
  window.klarnachrichten.trackMatomoEvent("search", filterStore.filters.searchTerm);
  load();
}

async function init() {
  await collectionStore.init();
  await filterStore.init();

  if (collectionStore.activeCollection) {
    filterStore.applyCollectionFilters(collectionStore.activeCollection.filters);
  }
}

async function load() {
  isReloading.value = true;
  await resultsStore.fetchResults(filterStore.filterQueryParams);
  isReloading.value = false;
}

init();
</script>

<template>
  <Hero
    @open-filter="filterModal.open()"
    @toggleOrder="toggleOrder()"
    @search="onSearch()"
    v-model="filterStore.searchTerm"
  />

  <div class="container">
    <div class="space-y-8 lg:space-y-10 mb-16 lg:mb-20">
      <ArticleRelationItemList
        :headline="$t('search.categories')"
        :items="resultsStore.results.categories"
        v-if="resultsStore.results.categories.length > 0"
      />

      <ArticleRelationItemList
        :headline="$t('search.persons')"
        :items="resultsStore.results.persons"
        v-if="resultsStore.results.persons.length > 0"
      />

      <ArticleRelationItemList
        :headline="$t('search.locations')"
        :items="resultsStore.results.locations"
        v-if="resultsStore.results.locations.length > 0"
      />

      <div v-if="resultsStore.results.articles.length > 0">
        <h2 v-t="'search.articles'" class="section-headline mb-3 lg:mb-6"></h2>
        <InfiniteArticleList :filters="filterStore.filterQueryParams" headline-tag="h3" :is-reloading="isReloading" />
      </div>
    </div>
  </div>

  <ModalsContainer />
</template>
